import React, { Component } from 'react';
import {
    MDBBreadcrumb,
    MDBBreadcrumbItem,
    MDBCard,
    MDBCardBody,
    MDBTable,
} from "mdbreact";
import { map } from 'lodash';
import LoadingSpinner from '../components/components/LoadingSpinner';
import { showYesNoConfirm } from '../helper/AlertHelper';


class Report_pendaftaran_pusat_detail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data_student: '',
            is_show: false,
            data: '',
            listMaster: {},
            reportExcel: [],
            report: [],
            isLoading: true,
            isBtndelete: false,
        }
    }

    getMaster(id = '', table) {
        var array = this.state.listMaster[table];
        var arrayfilter = array.filter((data) => { if (data.id == id) return data });
        var name = arrayfilter.length > 0 ? arrayfilter[0].name : '';
        return name;
    }

    getMasterBeforeState(id = 0, table) {
        var array = JSON.parse(localStorage.getItem('DATA_PARAMETER'))[table];
        var arrayfilter = array.filter((data) => { if (data.id == id) return data });
        var name = arrayfilter.length > 0 ? arrayfilter[0].name : '';
        return name;
    }

    getGuardianData(dataArray = []) {
        let result;
        let guardian = JSON.parse(localStorage.getItem('DATA_PARAMETER')).pdf_guardian;
        if (dataArray.length > 0) {
            var array = dataArray;
            const items = []
            map(guardian, (dt, idx) => {
                var arrayfilter = array.filter((data) => { if (parseInt(data.guardian_id) === parseInt(dt.id)) return data });
                var obj = { name: dt.name }
                var arrayResult = arrayfilter.length > 0 ? { ...arrayfilter[0], ...obj } : dt;
                items.push(arrayResult)
            });
            result = { data: items };
        } else {
            result = { data: [] };
        }
        return result;
    }

    onClickDelete = async (id, subdomain) => {
        const res = await showYesNoConfirm(
            "Anda yakin menghapus data ini?",
            "Data yang sudah dihapus tidak dapat dikembalikan lagi",
            "warning",
            "Ya, Hapus!",
            "Tidak",
        );

        if (res == null) {
            return;
        }
        if (res.dismiss) {
            return;
        }
        if (res.value) {
            this.setState({ isLoading: true });
            fetch(global.variable.LINK_API + 'student/delete',
                {
                    method: 'post',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        'Authorization': 'Bearer ' + global.cookies.get('access_token'),
                    },
                    body: JSON.stringify({ id: id, subdomain: subdomain }),
                },
            )
                .then(response => response.json())
                .then(resData => {
                    this.setState({ isLoading: false });
                    if (resData.message === "Success") {
                        global.swal("Success", resData.message, "success",);
                        window.location.reload();
                    } else {
                        global.swal("Error", resData.message, "info")
                    }
                });
        }
    }

    renderButtonDelete = (item) => {
        if (this.state.isBtndelete) {
            return (
                <>
                    <td>
                        <button
                            onClick={() => this.onClickDelete(item.id, item.subdomain)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                backgroundColor: "#dc2626",
                                color: "white",
                                padding: "8px 12px",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                            }}
                        >
                            Hapus
                        </button>
                    </td>
                </>
            );
        }
    }

    handleClick = param => e => {
        e.preventDefault();
        const findIdx = this.state.report.findIndex((i) => i.registration_id === param.trim());
        var dataStudent = this.state.report[findIdx]
        var dataJalur = dataStudent.registration_id + ' - ' + dataStudent.fullname;
        localStorage.setItem("DATA_JALUR", dataJalur);
        localStorage.setItem("STUDENT_DETAIL", JSON.stringify(dataStudent));
        window.open("/detailstudent", '_blank');
    }

    async componentDidMount() {
        let data_report;
        var param = JSON.parse(localStorage.getItem('pusat_data'));
        var split = param.split('/');
        var unit = split[0];
        var year = split[1];
        var status = split[2];
        const formData = new FormData();
        formData.append('type', 'registration');
        formData.append('subdomain', unit);
        if (year !== '') {
            formData.append('year', year);
        }
        if (status !== '') {
            formData.append('flow', status);
        }
        this.setState({
            isLoading: true,
        })

        await fetch(global.variable.LINK_API + 'report/list-by-unit',
            {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    'Authorization': 'Bearer ' + global.cookies.get('access_token'),
                },
                body: formData,
            })
            .then(response => response.json())
            .then(resData => {
                if (resData.code === 200) {
                    data_report = resData.data;
                } else {
                    global.swal("Error", resData.message, "info")
                    return;
                }
            });

        await this.checkUserAccess();

        let master = JSON.parse(localStorage.getItem('DATA_PARAMETER'));
        const data = [];
        data_report.map((item) => {
            const dataStudent = [];
            let items = Object.create({});
            items['Nomor Pendaftaran'] = item.year + '-' + item.registration_type_id + '-' + item.registration_number
            master.prm_ms_student.map((data2) => {
                if (data2.pdf_table) {
                    items[data2.name.trim()] = this.getMasterBeforeState(item[data2.field], data2.pdf_table)
                } else {
                    if (data2.field === 'hp') {
                        items[data2.name.trim()] = item[data2.field] ? item[data2.field].replace("+62", "0") : '';
                    } else {
                        items[data2.name.trim()] = item[data2.field] ? item[data2.field] : '';
                    }
                }
            });
            items['Keadaan Orang Tua'] = this.getMasterBeforeState(item.parent_status_id, 'pdf_parent_status');
            items['Keadaan Pekerjaan Orang Tua'] = this.getMasterBeforeState(item.working_parent_id, 'pdf_working_parents');
            let guardian = JSON.parse(localStorage.getItem('DATA_PARAMETER')).pdf_guardian;
            if (item.guardian.length > 0) {
                var gd = this.getGuardianData(item.guardian);
                const data2 = [];
                map(gd.data, (dt) => {
                    let items2 = Object.create({});
                    if ('student_id' in dt) {
                        items2[`Orang Tua ${dt.name}`] = dt.name;
                        items2[`Nama Lengkap ${dt.name}`] = dt.fullname;
                        items2[`NIK ${dt.name}`] = dt.nik;
                        items2[`Tanggal Lahir ${dt.name}`] = dt.dob;
                        items2[`Agama ${dt.name}`] = this.getMasterBeforeState(dt.religion_guardian_id, 'pdf_religion');
                        items2[`Status ${dt.name}`] = this.getMasterBeforeState(dt.status_guardian_id, 'pdf_parent_status');
                        items2[`Pendidikan ${dt.name}`] = this.getMasterBeforeState(dt.education_id, 'pdf_education_guardian');
                        items2[`Pekerjaan ${dt.name}`] = this.getMasterBeforeState(dt.occupation_id, 'pdf_occupation');;
                        items2[`Penghasilan ${dt.name}`] = dt.salary;
                        items2[`No HP. ${dt.name}`] = dt.hp.replace("+62", "0");
                        items2[`Alamat ${dt.name}`] = dt.address;
                    } else {
                        items2[`Orang Tua ${dt.name}`] = dt.name;
                        items2[`Nama Lengkap ${dt.name}`] = '';
                        items2[`NIK ${dt.name}`] = '';
                        items2[`Tanggal Lahir ${dt.name}`] = '';
                        items2[`Agama ${dt.name}`] = '';
                        items2[`Status ${dt.name}`] = '';
                        items2[`Pendidikan ${dt.name}`] = '';
                        items2[`Pekerjaan ${dt.name}`] = '';
                        items2[`Penghasilan ${dt.name}`] = '';
                        items2[`No HP. ${dt.name}`] = '';
                        items2[`Alamat ${dt.name}`] = '';
                    }
                    data2.push(items2)
                })
                var newObj = Object.assign({}, ...data2);
                items = { ...items, ...newObj }
            } else {
                const data2 = [];
                map(guardian, (dt) => {
                    let items2 = Object.create({});
                    items2[`Orang Tua ${dt.name}`] = dt.name;
                    items2[`Nama Lengkap ${dt.name}`] = '';
                    items2[`NIK ${dt.name}`] = '';
                    items2[`Tanggal Lahir ${dt.name}`] = '';
                    items2[`Agama ${dt.name}`] = '';
                    items2[`Status ${dt.name}`] = '';
                    items2[`Pendidikan ${dt.name}`] = '';
                    items2[`Pekerjaan ${dt.name}`] = '';
                    items2[`Penghasilan ${dt.name}`] = '';
                    items2[`No HP. ${dt.name}`] = '';
                    items2[`Alamat ${dt.name}`] = '';
                    data2.push(items2)
                })
                var newObj = Object.assign({}, ...data2);
                items = { ...items, ...newObj }
            }
            items[`Catatan`] = item.note_verification ? item.note_verification : '';
            data.push(items)
        })
        this.setState({
            report: data_report,
            listMaster: master,
            reportExcel: data,
            isLoading: false,
        })
    }

    checkUserAccess = async () => {
        const levelId = localStorage.getItem('levels_id');
        await fetch(global.variable.LINK_API + 'user/access', {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + global.cookies.get('access_token'),
            },
            body: JSON.stringify({ user_level_id: levelId, user_access_id: '2' }),
        })
            .then(response => response.json())
            .then(resData => {
                if (resData.code === 200) {
                    this.setState({ isBtndelete: resData.data });
                } else {
                    global.swal("Error", 'Gagal mengambil data akses user', "info")
                }
            });
    }

    render() {
        let counter = 0;
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="divContainter">
                                    <MDBCard className="mb-5">
                                        <MDBCardBody>
                                            <MDBBreadcrumb color="cyan lighten-4">
                                                <MDBBreadcrumbItem active>
                                                    <a href="/home">Home</a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    Laporan Pendaftaran
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>
                                            {
                                                this.state.isLoading ? <LoadingSpinner /> : ""
                                            }
                                            <MDBTable >
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Nama Lengkap</th>
                                                        <th>Nomor Pendaftaran</th>
                                                        <th>Nomor Handphone</th>
                                                        <th>Status</th>
                                                        <th>Catatan Verifikasi</th>
                                                        {this.state.isBtndelete ? <th></th> : null}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.report.map((item, index) => {
                                                        counter++;
                                                        return (
                                                            <tr key={index}>
                                                                <td>{counter}</td>
                                                                <td>{item.fullname}</td>
                                                                <td>{item.year + '-' + item.registration_number}</td>
                                                                <td>{item.hp ? item.hp.replace("+62", "0") : ''}</td>
                                                                <td>{this.getMaster(item.flow_id, 'pdf_flow')}</td>
                                                                <td>{item.note_verification}</td>
                                                                {this.renderButtonDelete(item)}
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </MDBTable>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Report_pendaftaran_pusat_detail;